// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body {
  background-color: #000;
  color: #fff;
}

.client-screen {
  min-height: 100vh;
  padding: 40px;
  text-align: center !important;
  background-color: #000;
}

input {
  padding: 10px;
  margin: 10px;
}

button {
  padding: 10px 20px;
  cursor: pointer;
}

.error {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/styles/client.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ","sourcesContent":["html, body {\n  background-color: #000;\n  color: #fff;\n}\n\n.client-screen {\n  min-height: 100vh;\n  padding: 40px;\n  text-align: center !important;\n  background-color: #000;\n}\n\ninput {\n  padding: 10px;\n  margin: 10px;\n}\n\nbutton {\n  padding: 10px 20px;\n  cursor: pointer;\n}\n\n.error {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
